import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}

import { ref, useAttrs, computed } from 'vue';

  export interface IProps {
    loading?: boolean;
    disabled?: boolean;
    onClick?: Function;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    loading: { type: Boolean },
    disabled: { type: Boolean },
    onClick: null
  },
  setup(__props: any) {

const props = __props as {
    loading?: boolean;
    disabled?: boolean;
    onClick?: Function;
  }

  
  const attrs = useAttrs();
  const componentLoading = ref(false);

  const loading = computed(() => {
    return componentLoading.value || props.loading;
  });

  const buttonProps = computed(() => {
    return {
      ...attrs,
      disabled: props.disabled || loading.value,
    };
  });

  const onClick = async (event: Event) => {
    const onClick = props.onClick;
    if (onClick) {
      componentLoading.value = true;
      try {
        await onClick(event);
      } finally {
        componentLoading.value = false;
      }
    }
  };


return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(_component_b_button, _mergeProps(_unref(buttonProps), { onClick: onClick }), {
    default: _withCtx(() => [
      (_unref(loading))
        ? (_openBlock(), _createElementBlock("span", _hoisted_1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})